export const GTM_ID = process.env.GATSBY_GTM_ID && (process.env.NODE_ENV === `production` || process.env.GATSBY_GTM_DEV === '1') ? process.env.GATSBY_GTM_ID : null;
